export default __webpack_public_path__ + "static/media/k2.e6854d1f.jpg";